// common
import { HTMLProps, memo, useState } from 'react';

// style
import styles from './style';
import Button from '../button';
import { UseFormRegisterReturn } from 'react-hook-form';

// Props Interface
interface Props extends HTMLProps<HTMLTextAreaElement> {
  secure?: boolean
  disabled?: boolean
  submitBtnText?: string
  onSubmit?: () => void
  onChangeText?: any
  onBlur?: () => void
  bottomLine?: boolean
  bordered?: boolean
  width?: number | string
  height?: number | string
  textAlign?: any
  unit?: any
  description?: string
  defaultValue?: any
  textContentType?: string | undefined
  rows?: number

  inputStyle?: any;
  mask?: any;
  margin?: number | any;
  marginBottom?: number | any;
  marginRight?: number | any;

  right?: any;
  icon?: any;

  register?: UseFormRegisterReturn<any>;
  autoResize?: boolean;
}

const TextArea: React.FunctionComponent<Props> = (props: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  const onBlur = () => {
    setIsFocused(false);
    props.onBlur?.();
  };

  const onFocus = () => {
    setIsFocused(true);
  };

  const margin = props.margin !== undefined ? { margin: props.margin } : null;
  const marginBottom =
    props.marginBottom !== undefined ? { marginBottom: props.marginBottom } : styles.defaultMarginBottom;
  const marginRight = props.marginRight ? { marginRight: props.marginRight } : {};

  const bordered = props.bordered ? styles.inputFieldBorder : null;
  const width = props.width ? { width: props.width } : {};
  const height = props.height ? { height: props.height } : {};
  const textAlign = props.textAlign ? { textAlign: props.textAlign } : null;

  const focused = isFocused ? styles.inputFieldFocused : null;

  const bottomLine = props.bottomLine === false ? null : styles.inputFieldBottomLine;

  let iconStyles = {};
  switch (props.icon?.position) {
    case 'left':
      iconStyles = styles.leftIcon;
      break;
    case 'right':
      iconStyles = styles.rightIcon;
      break;
    case 'centerLeft':
      iconStyles = {};
      break;
    case 'centerRight':
      iconStyles = {};
      break;
  }

  const renderIcons = () => {
    return <div style={iconStyles}>{props.icon?.icon}</div>;
  };

  const renderDescription = () => {
    if (!props.description) {
      return null;
    }

    return <span style={styles.descriptionText}>{props.description}</span>;
  };
  const submitBtn = () => {
    if (!props.submitBtnText) {
      return null;
    }

    return (
      <>
        <div style={styles.submitButtonContainer}>
          <Button text={props.submitBtnText} />
        </div>
      </>
    );
  };

  const renderUnit = () => {
    if (!props.unit) {
      return null;
    }

    return (
      <div style={styles.unitContainer}>
        <span
          style={{
            ...styles.unitText,
            ...styles.inputField,
            ...textAlign,
          }}
        >
          {props.unit}
        </span>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.inputFieldContainer,
          ...focused,
          ...width,
          ...height,
          ...margin,
          ...marginBottom,
          ...marginRight,
          ...bottomLine,
          ...focused,
          ...bordered,
        }}
      >
        <div style={styles.inner}>
          {props.icon?.position === 'left' ? renderIcons() : null}
          {props.icon?.position === 'centerLeft' ? renderIcons() : null}

          <textarea
            rows={props.rows}
            className="p-4"
            disabled={props.disabled}
            onBlur={props.onBlur != null ? onBlur : undefined}
            // onFocus={onFocus}
            style={{
              ...styles.inputField,
              ...textAlign,
              ...props.inputStyle,
              ...(props.autoResize
                ? {
                    resize: 'none',
                    fieldSizing: 'content',
                  }
                : {}),
            }}
            placeholder={props.placeholder}
            // placeholderTextColor={"#c8c8c8"}
            // returnKeyType={props.returnKeyType}
            value={props.value}
            // secureTextEntry={props.secure}
            // textContentType={
            //     props.secure ? "oneTimeCode" : null
            // }
            onChange={(event) => {
              props.onChangeText(event.target.value);
            }}
            // keyboardType={props.keyboardType}
            // autoCapitalize="none"
            // autoCorrect={false}
            // defaultValue={props.defaultValue}
            // editable={!props.disabled}
            // selectTextOnFocus={!props.disabled}
            maxLength={props.maxLength}
            {...props.register}
          />

          {renderUnit()}
          {submitBtn()}

          {props.icon?.position === 'centerRight' ? renderIcons() : null}
          {props.icon?.position === 'right' ? renderIcons() : null}
        </div>
      </div>
      {renderDescription()}
    </div>
  );
};

export default memo(TextArea);
